import React from"react";export var Cross=function Cross(){return/*#__PURE__*/React.createElement("i",{className:"fal fa-times"});};